"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLES = void 0;
var STYLES = exports.STYLES = {
  1: {
    tooltipColor: '#BF3FC1;',
    styleString: 'background: #FCEEFC; color: #BF3FC1;' // GOLD - в админке (Например, "Большая территория")
  },
  2: {
    tooltipColor: '#7441DF',
    styleString: 'background: #F4EFFF; color: #7441DF;' // PURPLE (Например, "Расположен в бухте")
  },
  3: {
    tooltipColor: '#DD6D1C',
    styleString: 'background: #FFF1EA; color: #DD6D1C;' // RED - в админке (Например, "Все включено")
  },
  4: {
    tooltipColor: '#0F648D',
    styleString: 'background: #E8F2F8; color: #0F648D;'
  },
  // WHITE - в админке (Например, "Сеть отелей "Hilton")
  5: {
    tooltipColor: '#047A94',
    styleString: 'background: #E1F5FA; color: #047A94;'
  },
  // GREY - в админке (Например, "Открылся в 2022 году")
  6: {
    tooltipColor: '#804d55',
    styleString: 'color: #804d55; background-color: #f7efe6; border: none;'
  },
  // RED FOR TRUST_YOU LABELS
  7: {
    tooltipColor: '#17181A',
    styleString: 'background: linear-gradient(90deg, #F9EEDF 0%, #EEF4D7 100%); color: #17181A;' // ORANGE_GREEN
  },
  10: {
    tooltipColor: '#FFFFFF',
    styleString: 'background: #0C73FE; color: #FFFFFF;' // Это стили для авиасейлс
  },
  998: {
    tooltipColor: '#BB4300',
    styleString: 'background: #F9ECD1; color: #BB4300;'
  },
  // BAD CONFIRMABILITY (Например, "Подтверждается хуже остальных")
  999: {
    tooltipColor: '#4453B1',
    styleString: "background: #E9EBF6; color: #4453B1;"
  },
  // Checkbox
  LABEL: {
    tooltipColor: 'var(--black)',
    styleString: "background: var(--background); color: var(--black);"
  },
  // Rebrand
  PLUS: {
    styleString: "background: var(--lightlime); color: var(--darklime);"
  },
  MINUS: {
    styleString: "background: var(--lightorange); color: var(--orange);"
  }
};